import { TextField } from "@mui/material";
import { useState } from "react";
import { useTranslations } from "use-intl";

import { Button } from "@/components/Button/Button";
import { DrawerTopBarWithAction } from "@/components/Drawer/DrawerTopBar";
import { SwipeableDrawer } from "@/components/Drawer/SwipeableDrawer";

type SearchByNameContentsProps = {
  value: string;
  onSubmit: (newQuery: string) => void;
  onClose: () => void;
};

export const SearchByNameContents = ({
  value,
  onSubmit,
  onClose,
}: SearchByNameContentsProps) => {
  const t = useTranslations();
  const [query, setQuery] = useState(value);

  return (
    <>
      <DrawerTopBarWithAction
        onCloseClick={onClose}
        title={t("hotels.filters.searchByName")}
        actionElement={
          <Button
            onClick={(e) => {
              setQuery("");

              // Remove focus from the button after click
              e.currentTarget.blur();
            }}
            variant="text"
            size="small"
          >
            {t("clearFilter")}
          </Button>
        }
      />

      <div className="mt-2">
        <TextField
          label={t("hotels.filters.enterHotelNameHere")}
          fullWidth
          value={query}
          onChange={(e) => setQuery(e.target.value)}
        />
      </div>

      <div className="mt-18">
        <Button
          fullWidth
          onClick={() => {
            onSubmit(query);
          }}
          variant="contained"
          size="large"
        >
          {t("apply")}
        </Button>
      </div>
    </>
  );
};

type Props = SearchByNameContentsProps & {
  open: boolean;
};

export const SearchByNameDrawer = ({
  open,
  value,
  onSubmit,
  onClose,
}: Props) => {
  return (
    <SwipeableDrawer open={open} onClose={onClose}>
      {/* need to reset the state when drawer is open/closed */}
      {open ? (
        <SearchByNameContents
          value={value}
          onSubmit={onSubmit}
          onClose={onClose}
        />
      ) : null}
    </SwipeableDrawer>
  );
};
